import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RangeQueryInterface } from '@sport-activities/sdk';
import { BehaviorSubject } from 'rxjs';

import { deepMerge } from '~/core/helpers/object/deep-merge/deep-merge.helper';

export interface ResultPageFilters {
  ageRange?: RangeQueryInterface<number>;
  city?: string;
  endDate?: string;
  page?: number;
  placeId?: string;
  priceRange?: RangeQueryInterface<number>;
  radius?: number;
  sportGroups?: number[];
  startDate?: string;
  // type?: string
  // level?: string
  // duration?: string
  // price?: string
}

@Injectable({
  providedIn: 'root',
})
export class ResultPageFilterService {
  public readonly filters$ = new BehaviorSubject<ResultPageFilters>({
    page: 1,
  });

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  public resetFilters(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: 1,
      },
    });
  }

  public updateFilters(filters: ResultPageFilters): void {
    this.filters$.next(
      deepMerge<ResultPageFilters>(this.filters$.getValue(), filters)
    );
  }
}
